import React, { useState } from 'react'
import { IInputProps } from '../../../types/interfaces/IInputProps'
import { OptionsWrapper } from './style'
import { InputContainer, Label } from '../input/style'
import { Error } from '../error/Error'
import RadioButton from '../radio-button/RadioButton'
import { GenderIdentity } from 'types/interfaces/IPersonalDetails'
import { useTranslation } from 'react-i18next'

export const GenderInput: React.FC<
  IInputProps & { value?: GenderIdentity }
> = ({ callback, hasError, errorText, className, value }) => {
  const [selected, setSelected] = useState(value ?? '')

  const { t } = useTranslation('', {
    keyPrefix: `pages.signUp.personalDetails`,
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelected(e.target.value)
    callback(e.target.value, false)
  }

  return (
    <InputContainer className={className ?? 'genderInput'}>
      <Label htmlFor="genderSelect">{t('inputs.gender.labelText')}</Label>
      <OptionsWrapper>
        <RadioButton
          id={'male'}
          label={t('inputs.gender.male')}
          value={GenderIdentity.MALE}
          isSelected={selected === GenderIdentity.MALE}
          callback={handleChange}
          seperator="/"
        ></RadioButton>
        <RadioButton
          id={'female'}
          label={t('inputs.gender.female')}
          value={GenderIdentity.FEMALE}
          isSelected={selected === GenderIdentity.FEMALE}
          callback={handleChange}
          seperator="/"
        ></RadioButton>
        <RadioButton
          id={'other'}
          label={t('inputs.gender.other')}
          value={GenderIdentity.OTHER}
          isSelected={selected === GenderIdentity.OTHER}
          callback={handleChange}
        ></RadioButton>
      </OptionsWrapper>
      <Error hasError={hasError} errorText={errorText}></Error>
    </InputContainer>
  )
}
